export default {
  type: 'layoutRows',
  shadow: '@theme:card.shadow',
  rounded: '@theme:card.rounded',
  fontName: '@theme:card.fontName',
  border: true,
  fontSize: '3',
  fareImageItem: {
    grow: '1',
  },
  fareContentItem: {
    grow: '2',
    padding: '2',
    justifyContent: 'between',
  },
  fareBodyItem: {
    textColor: 'dark',
  },
  fareFooterItem: {
    alignItems: 'end',
    textColor: 'dark',
  },
  showOriginDestinationImage: true,
  showOriginDestination: false,
  showRoute: false,
  showDepartureInfo: true,
  showReturnInfo: false,
  showJourneyType: false,
  showTravelClass: false,
  showPrice: true,
  fareItemOriginDestinationImage: {
    heightDestinationImage: 100,
    widthDestinationImage: 100,
    roundedLeft: '@theme:card.rounded',
  },
  fareItemOriginDestination: {
    showOriginAirportCode: false,
    showDestinationAirportCode: false,
    showSeparator: true,
    fontWeight: 'bold',
    fontSize: '4',
    marginBottom: '2',
    style: {
      lineHeight: '1',
    },
  },
  fareItemDepartureInfo: {
    showDepartureText: false,
    showDepartureDate: true,
  },
  fareItemJourneyType: {},
  fareItemTravelClass: {},
  fareItemRoute: {},
  fareItemReturnInfo: {},
  fareItemPrice: {
    pricePromoLabelKey: 'cmp-fare-price-promo-short',
    fontSize: '4',
    fontWeight: 'bold',
    marginLeft: 'auto',
    showCurrencyCode: true,
    showCurrencySymbol: false,
    showPricePromo: true,
    pricePromoStyles: {
      fontWeight: 'normal',
      fontSize: '3',
    },
    currencyStyle: {
      textColor: 'black',
    },
  },
};
